import React from 'react';
import { Route } from 'react-router-dom';

import { RoutesType } from '@/shared/types/route.type';

const RouteWithSubRoutes: React.FC<RoutesType> = ({ path, component }) => (
  <Route key={path} path={path} element={React.createElement(component)} />
);
export default RouteWithSubRoutes;
